import * as React from 'react'
import { Paper, Box } from '@mui/material'
import { createEffect, createStore } from 'effector'
import { useStore } from 'effector-react'
import api from '../../Auth/api'
import { BlockTitle } from '../../components/UI/BlockTitle/BlockTitle'
import SignedContractsReportFilter, {
  SignedContractsFilters,
  buildSignedContractsFilters,
  useSignedContractsFilters
} from '../../components/SignedContractsReportFilter'
import SignedContractsReportTable, {
  SignedContractsReportRow
} from '../../components/SignedContractsReportTable'

interface SignedContractsReportResponse {
  data: {
    rows: SignedContractsReportRow[]
  }
}

interface SignedContractsExportResponse {
  data: {
    bytes: string
  }
}

export const $signedContractsReport = createStore<SignedContractsReportRow[] | null>(null)

export const getSignedContractsReportFx = createEffect(
  async (params: SignedContractsFilters) => {
    const response = await api.post<SignedContractsReportResponse>(
      `report/signed-contracts`,
      params
    )
    return response
  }
)

export const exportSignedContractsReportFx = createEffect(
  async (params: SignedContractsFilters) => {
    const response = await api.post<SignedContractsExportResponse>(
      `report/signed-contracts-export`,
      params
    )
    return response
  }
)

$signedContractsReport.on(
  getSignedContractsReportFx.done,
  (_, { result }) => result.data.data.rows
)

const downloadExcel = (
  base64Bytes: string,
  fileName = 'Отчёт по подписанным договорам.xlsx'
) => {
  const link = document.createElement('a')
  link.href = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${base64Bytes}`
  link.download = fileName
  document.body.appendChild(link)
  link.click()
  link.remove()
}

export default function SignedContractsReport() {
  const report = useStore($signedContractsReport)
  const { isAccountPaid, isContractReturned } = useSignedContractsFilters()

  React.useEffect(() => {
    getSignedContractsReportFx(
      buildSignedContractsFilters(isAccountPaid, isContractReturned)
    )
  }, [isAccountPaid, isContractReturned])

  const handleExport = async () => {
    const result = await exportSignedContractsReportFx(
      buildSignedContractsFilters(isAccountPaid, isContractReturned)
    )
    const base64Bytes = result?.data?.data?.bytes
    if (base64Bytes) {
      downloadExcel(base64Bytes)
    }
  }

  return (
    <Paper sx={{ padding: '1rem', borderRadius: '1rem', mt: 3 }} elevation={0}>
      <Box display="flex" flexDirection="column" gap={2}>
        <BlockTitle backUrl="/reports" label="Отчёт по подписанным договорам" />

        <SignedContractsReportFilter onExport={handleExport} />

        <SignedContractsReportTable data={report} />
      </Box>
    </Paper>
  )
}
